import { Box, Flex } from "@chakra-ui/react";
import React from "react";
import Footer from "../../Components/Footer/Footer.js";
import Marketplace from "../../Components/Marketplace/Marketplace.js";

function MarketPlace() {


    return (
        <>
            <Flex justifyContent='center'>
                <Box maxWidth='1300px'>
                    <Marketplace />
                </Box>
            </Flex>
            <br />
            <Footer />
        </>
    );
}

export default MarketPlace;
